import QuestionNav from "pages/QuestionPage/QuestionNav/QuestionNav";

export default QuestionNav;
